<template>
  <v-container class="contenedor-ppal">
    <v-overlay :value="sisi">
      <div class="loader"></div>
    </v-overlay>

    <!-- INFORMACION TOOLBAR  -->
    <v-card elevation="4" class="mb-5">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-calendar-multiple</v-icon
          >
        </v-card>
        <div class="usuario">REPORTE POR FECHA</div>
        <!-- Para el cargo LÍDER SISTEMAS (Carlos) en REPORTE CALLCENTER,
             solo se mostrarán los casos de MESA DE SERVICIO / MESA DE AYUDA -->
        <div v-if="idCargo === 4" class="info-text-principal">
          <v-icon color="info" class="mr-2">mdi-information</v-icon>
          <strong
            >Solo se mostrarán casos de MESA DE SERVICIO (CALLCENTER)</strong
          >
        </div>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <!-- CAMPOS PARA FILTRADO POR FECHA -->
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateInit"
                  label="Fecha inicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateInit"
                @input="menu1 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateEnd"
                  label="Fecha final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateEnd"
                @input="menu2 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <v-select
              v-model="selectedEmpresa"
              :items="empresasOptions"
              item-text="text"
              item-value="value"
              label="Empresa"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :cols="$vuetify.breakpoint.xs ? 12 : reportes.length != 0 ? 3 : 5"
            class="mb-2"
          >
            <v-btn
              :block="$vuetify.breakpoint.xs"
              :disabled="!dateInit"
              @click="searchReports"
              color="#111c3d"
              dark
              class="responsive-btn"
              style="width: 100%"
            >
              <v-icon left>mdi-magnify</v-icon>
              <span v-if="!$vuetify.breakpoint.xs">Consultar</span>
              <span v-else>Buscar</span>
            </v-btn>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 3" class="mb-2">
            <div v-if="reportes.length != 0" style="width: 100%">
              <v-btn
                :block="$vuetify.breakpoint.xs"
                :loading="loading3"
                :disabled="loading3"
                color="green darken-3"
                class="ma-2 white--text responsive-btn"
                @click="downloadExcelJS"
                style="width: 100%"
              >
                <v-icon left> mdi-file-excel </v-icon>
                <span v-if="!$vuetify.breakpoint.xs">EXPORTAR EXCEL</span>
                <span v-else>Excel</span>
                <template v-slot:loader>
                  Exportando...
                  <span class="custom-loader">
                    <v-icon light>mdi-reload</v-icon>
                  </span>
                </template>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- DATA TABLE LISTADO DE REPORTES -->
    <v-text-field
      v-if="reportes != 0"
      v-model="search"
      append-icon="mdi-magnify"
      label="Filtrar busqueda"
      class="text-field"
      single-line
      color="#111c3d"
    ></v-text-field>
    <br />
    <!-- tabla donde se pintan los datos obtenidos del arreglo -->
    <v-data-table
      :headers="headers"
      :items="reportes"
      :search="search"
      style="border: 2px solid #111c3d"
      class="elevation-3"
    >
      <template v-slot:item.oculto="{ item }">
        <v-chip :color="getColor(item.oculto, item.cerrados)" outlined dark>
          <div class="mt-2" v-if="item.oculto == 0 && item.cerrados == 0">
            ERRONEO
          </div>
          <div v-else>CORRECTO</div>
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="#111c3d"
              @click.prevent="verConversacion(item)"
              >mdi-clipboard-text</v-icon
            >
          </template>
          <span>Ver detalles</span>
        </v-tooltip>

        <v-icon
          v-if="item.oculto == 0 && item.cerrados == 0"
          medium
          color="red darken-2"
          @click.prevent="deleteReport(item)"
          >mdi-delete</v-icon
        >
      </template>

      <template v-slot:[`item.cc_ruta`]="{ item }">
        <v-icon
          v-if="item.cc_ruta"
          color="light-blue"
          class="mr-2"
          @click="verImagen(item)"
          >mdi-image</v-icon
        >
      </template>

      <template v-slot:no-data>
        <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
          >No hay informacion para mostrar</v-alert
        >
      </template>
    </v-data-table>
    <!-- Dialog con la informacion adicional de cada reporte -->
    <v-row justify="center">
      <v-dialog v-model="dialog2" max-width="500px" persistent>
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-message-bulleted</v-icon>
              DETALLE DE REPORTE
            </span>
          </v-card-title>
          <v-card-text>
            <div v-for="(chat, index) in chatItem" :key="index">
              <v-card class="mt-3 mx-auto" width="550">
                <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                  <p class="indigo--text text--darken-3">
                    <v-icon color="indigo darken-4" class="ml-5 mr-1"
                      >mdi-robot</v-icon
                    >
                    {{ chat.user }}
                  </p>
                </v-card-subtitle>
                <v-card-subtitle v-else class="d-flex justify-end">
                  <p class="deep-purple--text text--accent-3">
                    <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                      >mdi-face</v-icon
                    >
                    {{ chat.user }}
                  </p>
                </v-card-subtitle>
                <v-card-text v-if="chat.user == 'NOVA'" class="">
                  <p class="grey--text text--darken-1 text-left">
                    {{ chat.message }}
                  </p>
                </v-card-text>
                <v-card-text v-else class="d-flex justify-end">
                  <p class="grey--text text--darken-1 text-right">
                    {{ chat.message }}
                  </p>
                </v-card-text>
              </v-card>
            </div>
            <v-divider class="mt-5"></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#1D3C7F"
              dark
              @click="verEvidencias(idCasoActual)"
              class="mr-2"
            >
              <v-icon left>mdi-image-multiple</v-icon>
              VER EVIDENCIAS
            </v-btn>
            <v-btn color="#1D3C7F" dark @click="dialog2 = false">CERRAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#111c3d"
      style="color: white"
    >
      {{ text }}
      <v-btn color="#111c3d" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogEvidencias" max-width="900px">
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image-multiple</v-icon>
            Evidencias del caso #{{ idCasoActual }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="cargandoEvidencias" class="text-center my-5">
              <v-progress-circular
                indeterminate
                color="#294697"
              ></v-progress-circular>
              <p>Cargando evidencias...</p>
            </div>
            <div v-else-if="!evidencias.length" class="text-center my-5">
              <v-alert type="info" outlined>
                No hay evidencias disponibles para este caso.
              </v-alert>
            </div>
            <v-row v-else>
              <v-col
                v-for="(evidencia, index) in evidencias"
                :key="index"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card outlined>
                  <template v-if="isImageUrl(evidencia.cc_ruta_evidencia)">
                    <v-img
                      :src="evidencia.cc_ruta_evidencia"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      @click="verImagenCompleta(evidencia.cc_ruta_evidencia)"
                      style="cursor: pointer"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#294697"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </template>
                  <template v-else>
                    <v-card
                      class="d-flex flex-column align-center justify-center pa-3"
                      style="cursor: pointer; aspect-ratio: 1; height: 100%"
                      @click="downloadFile(evidencia.cc_ruta_evidencia)"
                    >
                      <v-icon size="80" color="grey darken-1"
                        >mdi-file-document-outline</v-icon
                      >
                      <div
                        class="mt-2 text-caption grey--text text--darken-1 text-center"
                        style="word-break: break-all"
                      >
                        {{ getFileName(evidencia.cc_ruta_evidencia) }}
                      </div>
                    </v-card>
                  </template>
                  <v-card-text class="pa-2">
                    <small class="grey--text">{{
                      formatDate(evidencia.fecha_subida)
                    }}</small>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="closeEvidencias">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
      <v-card flat>
        <v-toolbar dark color="#1D3C7F" flat>
          <v-btn icon dark @click="descargarImagen">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-toolbar-title>Evidencia</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogImagenCompleta = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          class="pa-0 d-flex justify-center align-center"
          style="height: calc(100vh - 64px); background-color: #000"
        >
          <img
            :src="imagenSeleccionada"
            style="max-height: 95vh; max-width: 95vw; object-fit: contain"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImagenCierre"
      max-width="500px"
      max-height="400px"
      persistent
    >
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image</v-icon>
            Evidencia del Caso
          </span>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-img v-if="cc_ruta" :src="cc_ruta" alt="Imagen"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#294697" dark @click="dialogImagenCierre = false"
            >CERRAR</v-btn
          >
          <v-btn color="#1D3C7F" dark @click="aumentarImagen">Aumentar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "@/components/env";
import swal from "sweetalert";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
  name: "Fecha",
  data: () => ({
    //Varibales de uso para el snackbar
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    text: "",
    //Variables de uso para obtener lista de fechas
    dateInit: "",
    dateEnd: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    sisi: false,
    headers: [
      {
        text: "Numero de caso",
        align: "left",
        value: "cc_id_caso",
        align: "center",
        class: "column",
      },
      {
        text: "Requerimiento",
        align: "left",
        value: "cc_nombre_requerimiento",
        align: "center",
        class: "column",
      },
      {
        text: "Estado",
        align: "left",
        value: "oculto",
        align: "center",
        class: "column",
      },
      {
        text: "IP",
        align: "left",
        value: "ip",
        align: "center",
        class: "column",
      },
      {
        text: "Municipio",
        value: "municipio",
        align: "center",
        class: "column",
      },
      {
        text: "Punto",
        value: "punto",
        align: "center",
        class: "column",
      },
      {
        text: "Fecha apertura",
        value: "fecha_inicio",
        align: "center",
        class: "column",
      },
      {
        text: "Fecha cierre",
        value: "fecha_cierre",
        align: "center",
        class: "column",
      },
      {
        text: "Especialista",
        value: "nombre",
        align: "center",
        class: "column",
      },
      {
        text: "Imagen de cierre",
        value: "cc_ruta",
        align: "center",
        class: "column",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "action",
        sortable: false,
        align: "center",
        class: "column",
      },
    ],
    reportes: [],
    search: "",
    dialog2: false,

    //Variables de uso para exportar a excel
    nameFile: "",
    loader: null,
    loading3: false,
    chatItem: [],
    idCasoActual: null,
    dialogEvidencias: false,
    cargandoEvidencias: false,
    evidencias: [],
    imagenSeleccionada: "",
    dialogImagenCompleta: false,
    dialogImagenCierre: false,
    cc_ruta: "",
    idCargo: parseInt(localStorage.getItem("idCargo")) || 0,
    idArea: parseInt(localStorage.getItem("idArea")) || 0,
    selectedEmpresa: 0, // 0 = Todas las empresas
    empresasOptions: [
      { text: "Todas", value: 0 },
      { text: "FACILISIMO", value: 1 },
      { text: "APOSTAR", value: 2 },
    ],
  }),
  methods: {
    prioridad(value) {
      switch (value) {
        case "1":
          return "BAJA";
        case "2":
          return "MEDIA";
        case "3":
          return "ALTA";
      }
    },
    estado(value) {
      switch (value) {
        case "0":
          return "ABIERTO";
        case "1":
          return "SOLUCIONADO";
        case "2":
          return "ASIGNADO";
        case "3":
          return "SUSPENDIDO";
        case "4":
          return "VENCIDO";
        case "5":
          return "ANULADO";
      }
    },

    downloadExcel() {
      this.loading3 = true;
      const reportes = [];
      try {
        for (let i = 0; i < this.reportes.length; i++) {
          const item = {};
          item["ID"] = this.reportes[i].cc_id_caso;
          item["Cédula quien radica"] = this.reportes[i].cedula_asesor;
          item["Nombre quien radica"] = this.reportes[i].nombre_asesor;
          item["Área de servicio"] = this.reportes[i].cc_nombre_area;
          item["Punto de venta"] = this.reportes[i].punto;
          item["Empresa"] = this.reportes[i].punto;
          item["Requerimiento"] = this.reportes[i].cc_nombre_requerimiento;
          item["Vencidos"] =
            this.reportes[i].vencido == "1" ? "Vencido" : "No Vencido";
          item["Estado"] = this.estado(this.reportes[i].cerrados);
          item["Fecha inicio"] = this.reportes[i].fecha_inicio;
          item["Fecha cierre"] = this.reportes[i].fecha_cierre;
          item["Fecha vencimiento"] = this.reportes[i].fecha_vencimiento;
          //VENCIMIENTO FECHA
          item["Nombre responsable"] = this.reportes[i].nombre;
          item["Observaciones"] = this.reportes[i].observaciones;
          item["Conversacion"] = this.reportes[i].conversacion;
          const prioridad = this.prioridad(
            this.reportes[i].cc_prioridad_requerimiento,
          );
          item["Prioridad"] = this.prioridad(
            this.reportes[i].cc_prioridad_requerimiento,
          );
          // item["Municipio"] = this.reportes[i].municipio;
          // item["Punto"] = this.reportes[i].punto;
          // if (this.reportes[i].escalamiento == null) {
          //   item["Area escalamiento"] = "SIN ESCALAR";
          //   item["Requerimiento escalado"] = "SIN ESCALAR";
          // } else {
          //   item["Area escalamiento"] = this.reportes[i].escalamiento.area;
          //   item["Requerimiento escalado"] = this.reportes[i].escalamiento.requerimiento;
          // }
          // item["Observaciones"] = this.reportes[i].observaciones;
          // if (this.reportes[i].oculto == 0 && this.reportes[i].cerrados == 0) {
          //   item["Estado del caso"] = "ERRONEO";
          // } else {
          //   item["Estado del caso"] = "CORRECTO";
          // }
          reportes.push(item);
        }
      } catch (error) {
        console.log(error);
        this.loading3 = false;
      }
      const data = XLSX.utils.json_to_sheet(reportes);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `Reportes${this.dateInit}-al-${this.dateEnd}.xlsx`);
      this.loading3 = false;
    },
    async downloadExcelJS() {
      this.loading3 = true;

      // Asegurar que tenemos el idCargo e idArea correctos
      const idCargoActual =
        this.idCargo || parseInt(localStorage.getItem("idCargo")) || 0;
      const idAreaActual =
        this.idArea || parseInt(localStorage.getItem("idArea")) || 0;

      try {
        const workbook = new ExcelJS.Workbook();

        // Filtrar datos según el idCargo y idArea
        let tecnologia = [];
        let mesa = [];
        let mantenimiento = [];
        let logistica = [];
        let areaUsuario = [];
        let nombreAreaUsuario = "";

        // Obtener el nombre del área del usuario
        const obtenerNombreArea = (idArea) => {
          const areas = {
            1: "ADMINISTRATIVA",
            3: "CARTERA",
            13: "GESTIÓN DOCUMENTAL",
            14: "GESTIÓN HUMANA",
            23: "SEGURIDAD Y RECAUDO",
            24: "MANTENIMIENTO",
            25: "LOGÍSTICA",
            27: "TECNOLOGÍA",
            11: "MESA DE SERVICIO",
          };
          return areas[idArea] || "ÁREA GENERAL";
        };

        if (idCargoActual === 3 || idCargoActual === 4) {
          // Para idCargo 3 y 4 (MESA-TECNOLOGIA): SISTEMAS y MESA DE SERVICIO
          tecnologia = this.reportes.filter(
            (r) =>
              r.cc_nombre_area &&
              r.cc_nombre_area.toUpperCase().includes("SISTEMAS"),
          );
          mesa = this.reportes.filter(
            (r) =>
              r.cc_nombre_area &&
              (r.cc_nombre_area.toUpperCase().includes("MESA DE SERVICIO") ||
                r.cc_nombre_area.toUpperCase().includes("MESA DE AYUDA")),
          );
        } else if (idCargoActual === 15 || idCargoActual === 16) {
          // Para idCargo 128 (MANTENIMIENTO - LOGISTICA): MANTENIMIENTO y LOGÍSTICA
          mantenimiento = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 12,
          );
          logistica = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 11,
          );
        } else if (idCargoActual === 28) {
          // Para idCargo 28: TODAS las áreas
          tecnologia = this.reportes.filter(
            (r) =>
              r.cc_nombre_area &&
              r.cc_nombre_area.toUpperCase().includes("TECNOLOGIA"),
          );
          mesa = this.reportes.filter(
            (r) =>
              r.cc_nombre_area &&
              (r.cc_nombre_area.toUpperCase().includes("MESA DE SERVICIO") ||
                r.cc_nombre_area.toUpperCase().includes("MESA DE AYUDA")),
          );
          mantenimiento = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 24,
          );
          logistica = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 25,
          );

          // Filtrar por las nuevas áreas
          const gestionHumana = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 14,
          );
          const cartera = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 3,
          );
          const gestionDocumental = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 13,
          );
          const seguridadRecaudo = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 23,
          );
          const administrativa = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == 1,
          );

          // Crear hojas para todas las áreas disponibles
          if (gestionHumana.length > 0) {
            const wsGH = workbook.addWorksheet("GESTIÓN HUMANA");
            await crearHoja(wsGH, gestionHumana, "GESTIÓN HUMANA");
          }
          if (cartera.length > 0) {
            const wsCar = workbook.addWorksheet("CARTERA");
            await crearHoja(wsCar, cartera, "CARTERA");
          }
          if (gestionDocumental.length > 0) {
            const wsGD = workbook.addWorksheet("GESTIÓN DOCUMENTAL");
            await crearHoja(wsGD, gestionDocumental, "GESTIÓN DOCUMENTAL");
          }
          if (seguridadRecaudo.length > 0) {
            const wsSR = workbook.addWorksheet("SEGURIDAD Y RECAUDO");
            await crearHoja(wsSR, seguridadRecaudo, "SEGURIDAD Y RECAUDO");
          }
          if (administrativa.length > 0) {
            const wsAdm = workbook.addWorksheet("ADMINISTRATIVA");
            await crearHoja(wsAdm, administrativa, "ADMINISTRATIVA");
          }
        } else {
          // Para otros cargos: Filtrar por el área específica del usuario
          areaUsuario = this.reportes.filter(
            (r) => r.cc_id_area && r.cc_id_area == idAreaActual,
          );
          nombreAreaUsuario = obtenerNombreArea(idAreaActual);

          // Si no hay datos para el área específica, mostrar TECNOLOGÍA y MESA DE SERVICIO como fallback
          if (areaUsuario.length === 0) {
            tecnologia = this.reportes.filter(
              (r) =>
                r.cc_nombre_area &&
                r.cc_nombre_area.toUpperCase().includes("TECNOLOGIA"),
            );
            mesa = this.reportes.filter(
              (r) =>
                r.cc_nombre_area &&
                (r.cc_nombre_area.toUpperCase().includes("MESA DE SERVICIO") ||
                  r.cc_nombre_area.toUpperCase().includes("MESA DE AYUDA")),
            );
          }
        }

        const getNombreEmpresa = (r) => {
          if (r.nombreEmpresa) {
            return r.nombreEmpresa.toUpperCase();
          }

          if (r.idEmpresa == 1) return "FACILISIMO";
          if (r.idEmpresa == 2) return "APOSTAR";

          return "SIN EMPRESA";
        };

        // Función para crear hoja con diseño
        const crearHoja = async (ws, datos, nombre) => {
          // Detectar empresas presentes en los datos
          const empresasEnDatos = new Set();

          datos.forEach((r) => {
            const empresa = getNombreEmpresa(r);

            if (empresa.includes("FACILISIMO")) {
              empresasEnDatos.add("FACILISIMO");
            } else if (empresa.includes("APOSTAR")) {
              empresasEnDatos.add("APOSTAR");
            }
          });

          const tieneFacilisimo = empresasEnDatos.has("FACILISIMO");
          const tieneApostar = empresasEnDatos.has("APOSTAR");
          const tieneAmbas = tieneFacilisimo && tieneApostar;
          // SOLO FACILISIMO
          if (tieneFacilisimo && !tieneApostar) {
            const facilisimoLogo = await fetch(
              require("@/assets/LOGO-FACILISIMO-GRIS.png"),
            ).then((r) => r.arrayBuffer());
            const facilisimoId = workbook.addImage({
              buffer: facilisimoLogo,
              extension: "png",
            });
            ws.addImage(facilisimoId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          }
          // SOLO APOSTAR
          else if (tieneApostar && !tieneFacilisimo) {
            const apostarLogo = await fetch(
              require("@/assets/nova/LOGO APOSTAR-06.png"),
            ).then((r) => r.arrayBuffer());
            const apostarId = workbook.addImage({
              buffer: apostarLogo,
              extension: "png",
            });
            ws.addImage(apostarId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          }
          // AMBAS
          else if (tieneAmbas) {
            const facilisimoLogo = await fetch(
              require("@/assets/LOGO-FACILISIMO-GRIS.png"),
            ).then((r) => r.arrayBuffer());
            const apostarLogo = await fetch(
              require("@/assets/nova/LOGO APOSTAR-06.png"),
            ).then((r) => r.arrayBuffer());

            const facilisimoId = workbook.addImage({
              buffer: facilisimoLogo,
              extension: "png",
            });
            const apostarId = workbook.addImage({
              buffer: apostarLogo,
              extension: "png",
            });

            ws.addImage(facilisimoId, {
              tl: { col: 7, row: 0 },
              ext: { width: 120, height: 60 },
            });
            ws.addImage(apostarId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          }
          // DEFAULT
          else {
            const apostarLogo = await fetch(
              require("@/assets/nova/LOGO APOSTAR-06.png"),
            ).then((r) => r.arrayBuffer());
            const apostarId = workbook.addImage({
              buffer: apostarLogo,
              extension: "png",
            });
            ws.addImage(apostarId, {
              tl: { col: 9, row: 0 },
              ext: { width: 120, height: 60 },
            });
          }
          // Insertar logos
          const novaLogo = await fetch(
            require("@/assets/nova/Logo_nova.png"),
          ).then((r) => r.arrayBuffer());
          const novaId = workbook.addImage({
            buffer: novaLogo,
            extension: "png",
          });
          ws.addImage(novaId, {
            tl: { col: 0, row: 0 },
            ext: { width: 120, height: 60 },
          });
          // Título centrado
          if (tieneAmbas) {
            ws.mergeCells("C1", "F2");
          } else {
            ws.mergeCells("C1", "I2");
          }
          ws.getCell("C1").value = `Reporte de Casos - ${nombre}`;
          ws.getCell("C1").alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          ws.getCell("C1").font = {
            size: 18,
            bold: true,
            color: { argb: "FFFFFFFF" },
          };
          // Fondo azul en la parte superior
          for (let row = 1; row <= 2; row++) {
            for (let col = 1; col <= 14; col++) {
              const cell = ws.getCell(row, col);
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF294697" },
              };
            }
          }
          ws.getRow(1).height = 30;
          ws.getRow(2).height = 30;
          // Encabezados
          ws.addRow([]); // Espacio
          ws.addRow([
            "ID",
            "Cédula",
            "Nombre Completo",
            "Área de servicio",
            "Punto de venta",
            "Empresa",
            "Requerimiento",
            "Vencidos",
            "Estado",
            "Fecha inicio",
            "Fecha cierre",
            "Fecha vencimiento",
            "Nombre responsable",
            "Observaciones",
            "Conversacion",
            "Prioridad",
          ]);
          ws.getRow(4).eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF1D3C7F" },
            };
            cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
            cell.border = {
              top: { style: "medium", color: { argb: "FF000000" } },
              left: { style: "medium", color: { argb: "FF000000" } },
              bottom: { style: "medium", color: { argb: "FF000000" } },
              right: { style: "medium", color: { argb: "FF000000" } },
            };
          });
          // Datos
          datos.forEach((r) => {
            ws.addRow([
              r.cc_id_caso,
              r.cedula_asesor,
              r.nombre_asesor,
              r.cc_nombre_area,
              r.punto,
              getNombreEmpresa(r),
              r.cc_nombre_requerimiento,
              r.vencido == 1 ? "Vencido" : "No Vencido",
              this.estado(r.cerrados),
              r.fecha_inicio,
              r.fecha_cierre,
              r.fecha_vencimiento,
              r.nombre,
              r.observaciones,
              r.conversacion,
              this.prioridad(r.cc_prioridad_requerimiento),
            ]);
          });
          ws.columns.forEach((col, idx) => {
            if (idx === 2 || idx === 3) {
              // Cédula y Nombre
              col.width = 30;
            } else {
              col.width = 20;
            }
          });
        };

        // Crear hojas según el idCargo
        if (idCargoActual === 3 || idCargoActual === 4) {
          // Para idCargo 3 y 4 (MESA-TECNOLOGIA): SISTEMAS y MESA DE SERVICIO
          if (tecnologia.length > 0) {
            const wsTec = workbook.addWorksheet("SISTEMAS");
            await crearHoja(wsTec, tecnologia, "SISTEMAS");
          }
          if (mesa.length > 0) {
            const wsMesa = workbook.addWorksheet("MESA DE SERVICIO");
            await crearHoja(wsMesa, mesa, "MESA DE SERVICIO");
          }
        } else if (idCargoActual === 15 || idCargoActual === 16) {
          // Para idCargo 128 (MANTENIMIENTO - LOGISTICA): MANTENIMIENTO y LOGÍSTICA
          if (mantenimiento.length > 0) {
            const wsMant = workbook.addWorksheet("MANTENIMIENTO");
            await crearHoja(wsMant, mantenimiento, "MANTENIMIENTO");
          }
          if (logistica.length > 0) {
            const wsLog = workbook.addWorksheet("LOGISTICA");
            await crearHoja(wsLog, logistica, "LOGISTICA");
          }
        } else if (idCargoActual === 28) {
          // Todas las áreas para idCargo 28
          if (tecnologia.length > 0) {
            const wsTec = workbook.addWorksheet("TECNOLOGIA");
            await crearHoja(wsTec, tecnologia, "TECNOLOGIA");
          }
          if (mesa.length > 0) {
            const wsMesa = workbook.addWorksheet("MESA DE SERVICIO");
            await crearHoja(wsMesa, mesa, "MESA DE SERVICIO");
          }
          if (mantenimiento.length > 0) {
            const wsMant = workbook.addWorksheet("MANTENIMIENTO");
            await crearHoja(wsMant, mantenimiento, "MANTENIMIENTO");
          }
          if (logistica.length > 0) {
            const wsLog = workbook.addWorksheet("LOGISTICA");
            await crearHoja(wsLog, logistica, "LOGISTICA");
          }
        } else {
          // Para otros cargos: Crear hoja con el área específica del usuario
          if (areaUsuario.length > 0) {
            const wsArea = workbook.addWorksheet(nombreAreaUsuario);
            await crearHoja(wsArea, areaUsuario, nombreAreaUsuario);
          } else {
            // Fallback a TECNOLOGÍA y MESA DE SERVICIO si no hay datos para el área específica
            if (tecnologia.length > 0) {
              const wsTec = workbook.addWorksheet("TECNOLOGIA");
              await crearHoja(wsTec, tecnologia, "TECNOLOGIA");
            }
            if (mesa.length > 0) {
              const wsMesa = workbook.addWorksheet("MESA DE SERVICIO");
              await crearHoja(wsMesa, mesa, "MESA DE SERVICIO");
            }
          }
        }

        // Guardar archivo
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
          new Blob([buffer]),
          `Reportes${this.dateInit}-al-${this.dateEnd}.xlsx`,
        );
      } catch (e) {
        alert("Error exportando ExcelJS");
      }
      this.loading3 = false;
    },
    /**
     * Método para obtener el idCargo del usuario
     */
    obtenerUser() {
      const id = localStorage.getItem("id");
      if (id) {
        axios
          .get(`${env.endpoint}usuarios/getUser?id=${id}`)
          .then((res) => {
            if (res.data && res.data.length > 0) {
              this.idCargo = res.data[0].idCargo;
              this.idArea = res.data[0].idArea; // Obtener el idArea del usuario
              localStorage.setItem("idCargo", this.idCargo.toString());
              localStorage.setItem("idArea", this.idArea.toString());
            }
          })
          .catch((error) => {
            console.error("Error obteniendo usuario:", error);
          });
      }
    },
    /**
     * Metodo que busca todos los reportes por dos fechas
     */
    searchReports() {
      this.sisi = true;
      const fechaInicio = this.dateInit;
      const fechaCierre = this.dateEnd;
      const id = localStorage.getItem("id");

      if (fechaInicio > fechaCierre) {
        this.snackbar = true;
        this.text =
          "Error, esta ingresando una fecha de inicio mayor a la final";
        this.dateInit = "";
        this.reportes = [];
        this.nameFile = "";
        this.sisi = false;
      } else {
        axios
          .get(
            `${env.endpoint}callcenter/reporteFechaCall?idUsuario=${id}&fechaInicio=${fechaInicio} 00:00:00&fechaFinal=${fechaCierre} 23:59:59&idEmpresa=${this.selectedEmpresa}`,
          )
          .then((res) => {
            this.sisi = false;
            let data = res.data || [];

            // Para el cargo LÍDER SISTEMAS (Carlos) en REPORTE CALLCENTER
            // solo deben verse los casos de MESA DE SERVICIO / MESA DE AYUDA
            if (this.idCargo === 4) {
              data = data.filter(
                (r) =>
                  r.cc_nombre_area &&
                  (r.cc_nombre_area
                    .toUpperCase()
                    .includes("MESA DE SERVICIO") ||
                    r.cc_nombre_area.toUpperCase().includes("MESA DE AYUDA")),
              );
            }

            this.reportes = data;
            this.nameFile = `casos ${fechaInicio} al ${fechaCierre}`;
          })
          .catch((error) => {
            // console.log();
          });
      }
    },
    /**
     * Metodo que activa la mnodal y muestra la conversacion
     */
    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      this.chatItem =
        typeof item.conversacion === "string"
          ? JSON.parse(item.conversacion)
          : item.conversacion;
    },
    /**
     * Metodo que elimina un reporte que no fue cerrado correctamente por el bot
     */
    deleteReport(item) {
      swal({
        title: "Este registro sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          // console.log(item.cc_id_caso);

          axios
            .get(`${env.endpoint}callcenter/delete_caso?id=${item.cc_id_caso}`)
            .then((res) => {
              this.searchReports();
            })
            .catch((error) => {
              // console.log();
            });
          swal("Registro eliminado con exito!", {
            icon: "success",
          });
        } else {
          swal("Proceso de eliminacion cancelado");
        }
      });
    },
    getColor(oculto, cerrados) {
      if (oculto == 0 && cerrados == 0) return "red darken-2";
      else return "green darken-3";
    },
    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];
      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
        })
        .catch((error) => {
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },
    descargarImagen() {
      const link = document.createElement("a");
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verImagen(item) {
      this.dialogImagenCierre = true;
      this.cc_ruta = item.cc_ruta;
    },
    aumentarImagen() {
      this.imagenSeleccionada = this.cc_ruta;
      this.dialogImagenCierre = false;
      this.dialogImagenCompleta = true;
    },
    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },
    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },
  },
  mounted() {
    // Ya tenemos idCargo / idArea en localStorage; evitamos llamada remota que da CORS/404
    // this.obtenerUser();
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
};
</script>

<style>
.text-field {
  border: 2px solid #111c3d;
  padding: 5px;
  border-radius: 5px;
}

.contenedor-ppal {
  border: 1px solid #111c3d;
  padding-bottom: 40px !important;
  border-radius: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #2981ec;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}
.responsive-btn {
  min-width: 120px;
  font-size: 1rem;
  padding: 0 16px;
}
@media (max-width: 600px) {
  .responsive-btn {
    width: 100% !important;
    min-width: unset !important;
    font-size: 0.95rem !important;
    margin-bottom: 8px !important;
    padding: 10px 0 !important;
  }
  .v-col {
    padding-left: 4px !important;
    padding-right: 4px !important;
    margin-bottom: 8px !important;
  }
  .v-text-field {
    font-size: 0.95rem !important;
  }
  .v-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.info-text-principal {
  font-size: 1rem;
  color: #1976d2;
  margin-left: 15px;
  display: flex;
  align-items: center;
  background-color: rgba(25, 118, 210, 0.1);
  padding: 8px 12px;
  border-radius: 6px;
  border-left: 4px solid #1976d2;
}
</style>
